import { Link, NavLink, Outlet } from "react-router-dom";
import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { IoArrowBack } from "react-icons/io5";

export default function Dashboard() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#0f1829]">
      {/* Sidebar */}
      <div
        className={`
          fixed top-0 left-0 h-full bg-[#111d42] border-r border-white/10 text-white p-5 z-40 transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          lg:relative lg:translate-x-0 lg:w-60 w-64
        `}
      >
        {/* Mobile close */}
        <div className="flex justify-between items-center mb-6 lg:hidden">
          <h2 className="text-base font-bold text-white/80">Menu</h2>
          <button onClick={() => setIsOpen(false)} aria-label="Close sidebar">
            <AiOutlineClose className="text-white/60 text-xl hover:text-white transition-colors" />
          </button>
        </div>

        {/* Back to home */}
        <Link
          to="/"
          className="flex items-center gap-2 text-sm text-white/50 hover:text-[#F05A22] transition-colors mb-8 font-medium"
        >
          <IoArrowBack />
          Back to Home
        </Link>

        <h2 className="text-xs font-semibold text-white/30 uppercase tracking-widest mb-4 hidden lg:block">
          Admin Panel
        </h2>

        <ul className="space-y-1">
          {[
            { to: "addUser", label: "Add New User" },
            { to: "manageUsers", label: "Manage Users" },
            { to: "managePrompts", label: "Manage Prompts" },
          ].map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `block px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? "bg-[#F05A22]/20 text-[#F05A22]"
                      : "text-white/60 hover:text-white hover:bg-white/10"
                  }`
                }
                onClick={() => setIsOpen(false)}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col bg-[#0f1829] overflow-auto">
        {/* Mobile hamburger */}
        <div className="lg:hidden p-4 border-b border-white/10">
          <button
            className="p-2 bg-[#1B2B5E] text-white rounded-lg border border-white/10"
            onClick={() => setIsOpen(true)}
          >
            <FiMenu className="text-xl" />
          </button>
        </div>

        <div className="flex-1 p-6 text-white">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
